const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

export function isCookieAuthMode() {
    const value = process.env.REACT_APP_AUTH_COOKIE_MODE || "false";
    return TRUE_VALUES.has(String(value).trim().toLowerCase());
}

export function shouldUseStoredAccessToken() {
    return !isCookieAuthMode();
}
